import { render } from "./CurrencyInputBox.vue?vue&type=template&id=c66946aa&scoped=true"
import script from "./CurrencyInputBox.vue?vue&type=script&lang=js"
export * from "./CurrencyInputBox.vue?vue&type=script&lang=js"

import "./CurrencyInputBox.vue?vue&type=style&index=0&id=c66946aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c66946aa"]])

export default __exports__